import React, { useState, useEffect } from "react";
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import useDataFlights from '../../../../../dataHooks/useDataFlights'
import FlightCardGroup from "./FlightCardGroup";
import { FaPlus } from 'react-icons/fa';
import AddEditFlightModal from './AddEditFlightModal/AddEditFlightModal'
import DeleteFlightModal from './DeleteFlightModal'
import { checkHasEditEventPermissions, checkHasEventTrainerPermissions } from '../../../../../utils';

export default ({
  eventData = {}
}) => {
  const hasEditPermissions = ( checkHasEditEventPermissions() || checkHasEventTrainerPermissions() );

  const {
    isLoading,
    flights,
    fetchFlights
  } = useDataFlights()

  useEffect(() => {
    fetchFlights({ eventId : eventData.id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData.id])

  const [addEditFlightObj, setAddEditFlightObj] = useState(undefined)
  const [deleteFlightObj, setDeleteFlightObj] = useState(undefined)

  const onAddNewFlight = () => {
    setAddEditFlightObj({})
  }

  const onEditFlight = (flightData) => {
    setAddEditFlightObj(flightData)
  }

  const onAddEditFlightSuccess = () => {
    setAddEditFlightObj(undefined)
    fetchFlights({ eventId : eventData.id })
  }

  const onDeleteFlight = (flightData) => {
    setDeleteFlightObj(flightData)
  }

  const onDeleteHotelSuccess = () => {
    setDeleteFlightObj(undefined)
    fetchFlights({ eventId : eventData.id })
  }

  return (
    <div
      style={{
        padding: '20px'
      }}
    >
      {
        Boolean(addEditFlightObj) &&
        <AddEditFlightModal 
          flightData={addEditFlightObj}
          eventId={eventData.id}
          onClose={() => setAddEditFlightObj(undefined)}
          onSuccess={onAddEditFlightSuccess}
        />
      }
      {
        Boolean(deleteFlightObj) &&
        <DeleteFlightModal 
          flightData={deleteFlightObj}
          onClose={() => setDeleteFlightObj(undefined)}
          onSuccess={onDeleteHotelSuccess}
        />
      }
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{
          flex: 1,
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          marginLeft: '20px'
        }}>
          {'Flight Itinerary'}
        </div>
        {
          hasEditPermissions &&
          <Button
            style={{
              display: 'inline-flex',
              padding: '8px 16px',
              marginRight: '20px'
            }}
            onClick={onAddNewFlight}
          >
            <FaPlus style={{ marginRight: '10px', color: '#0280c6' }} />
            <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Add Flight'}</span>
          </Button>
        }
      </div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            columnGap: '20px',
            rowGap: '20px',
            padding: '20px',
            flexWrap: 'wrap'
          }}>
            {flights.length > 0
              ?
              flights.map((flightGroup, index) => {
                return <FlightCardGroup key={`flightGroup-${index}`} flightGroupData={flightGroup} onEditFlight={onEditFlight} onDeleteFlight={onDeleteFlight} />
              })
              :
              <div>No flights have been added</div>
            }
          </div>
      }
    </div>
  )
}